import { useAccountTypeStructures } from "../../../hooks/useAccountTypeStructures";
import { CUSTOMER_ACCOUNT_TYPE } from "./customers.constants";

/**
 * Loads customer/supplier account structure and splits fields for search vs browse tables.
 */
export function useCustomerStructures() {
  return useAccountTypeStructures(CUSTOMER_ACCOUNT_TYPE);
}
